var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { collectionEngine, collectionEngineV1 } from '../apis';
const req = collectionEngine('/files');
const reqV1 = collectionEngineV1('/files');
export const save = (file, config) => __awaiter(void 0, void 0, void 0, function* () {
    const upload = yield reqV1('POST', `/${(config === null || config === void 0 ? void 0 : config.parseInvoice) ? '?parseInvoice=true' : ''}`, {
        body: file,
    });
    return {
        file: {
            contentType: file.contentType,
            fileName: file.name || upload.fileName,
            fileId: upload.id,
            meta: upload.meta,
        },
    };
});
export const get = (id, name) => req('GET', `/${id}${name != null ? name : ''}`);
//# sourceMappingURL=files.js.map